import { render, staticRenderFns } from "./LabelDetailEdit.vue?vue&type=template&id=4093e944&scoped=true&"
import script from "./LabelDetailEdit.vue?vue&type=script&lang=js&"
export * from "./LabelDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./LabelDetailEdit.vue?vue&type=style&index=0&id=4093e944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4093e944",
  null
  
)

export default component.exports